import React from 'react';
import ScrollToTop from 'components/scroll-to-top';
import ContactForm from './contact-form';

const ContactPage = () => (
  <div className="l-contact-page">
    <ScrollToTop />
    <div className="products-header -single">
      <h1>
        Contact
      </h1>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-md-8 cold-sm-12 offset-md-2">
          <ContactForm />
        </div>
      </div>
    </div>
  </div>
);

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact/index.js